import request from '@/router/axios';
export function getListpage(obj) {
  return request({
    url: '/driver/page',
    method: 'POST',
    data: obj,
  });
}
/**
 *  获取动态表单回显值
 */
export function getDynamicFormValue(id) {
  return request({
    url: '/driver/getDriverInfo/'+id,
    method: 'GET',
  });
}
/**
 *  根据id修改数据
 * @param obj
 */
export function updateListpage(obj) {
  return request({
    url: '/driver/update',
    method: 'put',
    data: obj,
  });
}

export function addListpage(obj) {
  return request({
    url: '/driver/add',
    method: 'post',
    data: obj,
  });
}
export function batchUpdate(obj) {
  return request({
    url: '/driver/batchUpdate',
    method: 'post',
    data: obj,
  });
}
export function exportDriver(obj) {
  return request({
    url: '/driver/exportDriver',
    responseType: 'blob', // 代表内存之中的一段二进制数据 必须加
    method: 'get',
    params: obj
  })
}
//查询司机概况
export function queryDriverTotal() {
  return request({
    url: '/driver/queryDriverTotal',
    method: 'GET',
  });
}
